module.exports = require("@material-ui/core/SvgIcon");